import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getSpecialClaimListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const params = { lookupHdrId: "SPECIAL_CLAIM_TYPE", sort: "seq,asc" };
		const res = await api.get.general.list(params);
		response = res.map(({ lookupTitle, lookupValue, ...o }) => ({ label: lookupTitle, value: lookupValue, ...o }));
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getSpecialClaimListing;
